import moment from "moment";

type DateRangePart = {
  year: string | number;
  month: string | number;
  date?: string | number;
};

type CampaignReportingPeriod = {
  reportingPeriod?: {
    from: DateRangePart;
    to: DateRangePart;
  };
};

type CustomRange = {
  from: DateRangePart;
  to: DateRangePart;
};

const parseDatePart = (value: string | number | undefined) =>
  parseInt(String(value));

export const campaignReportHelper = {
  getInitialCustomMonthRange,
  formatCustomRangeToSend,
  getInitialCustomDateRange,
};

function formatCustomRangeToSend(range: CustomRange) {
  const { from, to } = range;
  return {
    from: `${from.year}/${from.month}/01`,
    to: `${to.year}/${to.month}/01`,
  };
}

function getInitialCustomDateRange(campaign?: CampaignReportingPeriod | null) {
  const endMonth = moment().startOf("month");
  const startMonth = moment(endMonth).subtract(2, "month");
  let from: DateRangePart = {
    year: startMonth.format("YYYY"),
    month: startMonth.format("MM"),
    date: startMonth.format("DD"),
  };
  let to: DateRangePart = {
    year: endMonth.format("YYYY"),
    month: endMonth.format("MM"),
    date: endMonth.format("DD"),
  };

  if (!campaign) {
    return {
      from: {
        year: parseDatePart(from.year),
        month: parseDatePart(from.month),
        date: parseDatePart(from.date),
      },
      to: {
        year: parseDatePart(to.year),
        month: parseDatePart(to.month),
        date: parseDatePart(to.date),
      },
    };
  }

  const { reportingPeriod } = campaign;

  if (reportingPeriod) {
    from = reportingPeriod?.from;
    to = reportingPeriod?.to;
  }

  // if (campaign_type === "Normal") {
  //   from = {
  //     year: moment(start_date).format("YYYY"),
  //     month: moment(start_date).format("MM"),
  //   };
  //   to = {
  //     year: moment(end_date).format("YYYY"),
  //     month: moment(end_date).format("MM"),
  //   };
  //   if (reportingPeriod) {
  //     from = reportingPeriod?.from;
  //     to = reportingPeriod?.to;
  //   }
  // } else if (campaign_type === "Evergreen") {
  //   from = {
  //     year: moment().subtract(1, "year").format("YYYY"),
  //     month: moment().subtract(1, "year").format("MM"),
  //   };
  //   to = {
  //     year: moment().format("YYYY"),
  //     month: moment().format("MM"),
  //   };
  //   if (reportingPeriod) {
  //     from = reportingPeriod?.from;
  //     to = reportingPeriod?.to;
  //   }
  // }
  return {
    from: {
      year: parseDatePart(from.year),
      month: parseDatePart(from.month),
      date: parseDatePart(from.date),
    },
    to: {
      year: parseDatePart(to.year),
      month: parseDatePart(to.month),
      date: parseDatePart(to.date),
    },
  };
}

function getInitialCustomMonthRange(campaign?: CampaignReportingPeriod | null) {
  const endMonth = moment().startOf("month");
  const startMonth = moment(endMonth).subtract(2, "month");
  let from: DateRangePart = {
    year: startMonth.format("YYYY"),
    month: startMonth.format("MM"),
    date: startMonth.format("DD"),
  };
  let to: DateRangePart = {
    year: endMonth.format("YYYY"),
    month: endMonth.format("MM"),
    date: endMonth.format("DD"),
  };

  if (!campaign) {
    return {
      from: {
        year: parseDatePart(from.year),
        month: parseDatePart(from.month),
        date: parseDatePart(from.date),
      },
      to: {
        year: parseDatePart(to.year),
        month: parseDatePart(to.month),
        date: parseDatePart(to.date),
      },
    };
  }

  const { reportingPeriod } = campaign;

  if (reportingPeriod) {
    from = reportingPeriod?.from;
    to = reportingPeriod?.to;
  }

  return {
    from: {
      year: parseDatePart(from.year),
      month: parseDatePart(from.month),
      date: parseDatePart(from.date),
    },
    to: {
      year: parseDatePart(to.year),
      month: parseDatePart(to.month),
      date: parseDatePart(to.date),
    },
  };
}
